import { MovieDto } from '@interfaces/movieInterface';
import { movieService } from '@services/index';
import { useMutation } from '@tanstack/react-query';

export default function useMutationMovie() {
	return useMutation({
		mutationFn: ({ movieDto }: { movieDto: MovieDto }) => movieService.createMovie(movieDto)
	});
}
